import api from '@/services/api'

const state = {
	jobs: [
	],
	systemJobs: []
}

const getters = {
	getPendingJobs: (state) => {
		return state.jobs.filter(j => j.status == 'PENDING')
	},
	getRunningJobs: (state) => {
		return state.jobs.filter(j => j.status == 'RUNNING')
	},
	getCompletedJobs: (state) => {
		return state.jobs.filter(j => j.status == 'COMPLETED')
	},
	getErrorJobs: (state) => {
		return state.jobs.filter(j => j.status == 'ERROR')
	},
	getRunningSystemJobs: (state) => {
		return state.systemJobs.filter(j => j.triggerState == 'NORMAL')
	},
}

const actions = {
	async poll({ commit }) {
		const response = await api().get('/jobs')
		commit('setJobs', response.data.data)
	},
	async setJobRead({ commit }, id) {
		await api().post(`/jobs/read/${id}`)
		const response = await api().get('/jobs')
		commit('setJobs', response.data.data)
	},
	async listenSystemJobs({ commit }) {
		//const response = await api().get('/jobs/system')
		//commit('setSystemJobs', response.data.data)

		const evtSource = new EventSource("/api/v1/jobs/system/sse", {
			withCredentials: true,
			rejectUnauthorized: false
		});

		evtSource.onmessage = (event) => {
			const jobs = JSON.parse(event.data)
			commit('setSystemJobs', jobs)
		};
		evtSource.onerror = (error) => {
			console.error(error, error.status);
		};
		evtSource.onopen = (event) => {
			console.log("open", event);
		};
	}
}

const mutations = {
	setJobs(state, jobs) {
		state.jobs = jobs
	},
	setSystemJobs(state, jobs) {
		state.systemJobs = jobs
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/jobs.js